import React, {FC, useEffect, useState} from 'react';

import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {ArrowDown, Icon} from '@optimaxdev/icons';
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {BaseLensesProductItem} from 'components/baseProductItems/baseLensesProductItem/baseLensesProductItem';
import {ProductName} from 'components/baseProductItems/productName/productName';
import {GENERAL_EXPERIMENT_INDICATION} from 'constants/analytics/events/general';
import {CheckoutItemType} from 'desktop/types/checkoutItemsType';
import {flags} from 'libs/rollout';

import {LensesCartItemDetails} from '../../lensesCartItemDetails/lensesCartItemDetails';
import s from '../productItem.scss';

import {isUserHas10PercentCLDiscount} from './helpers';
import {LensesSubscriptionQuantity} from './lensesSubscriptionQuantity/lensesSubscriptionQuantity';

export type PropsType = {
    item: CheckoutItemType;
};

/**
 * Product Contact lenses Item facelift for checkout page
 */
export const ContactLensesProductItem: FC<PropsType> = ({item}) => {
    const [isOpened, setIsOpened] = useState(false);

    useEffect(() => {
        if (!isUserHas10PercentCLDiscount() || item.sku.includes('PLA')) return;
        sendDesktopAnalyticsPerSession({
            event: GENERAL_EXPERIMENT_INDICATION,
            isInteraction: false,
            label: {
                expName: 'dReturningCustomerCL',
                label: flags.dReturningCustomerCL.isEnabled(),
            },
        });
    }, [item.sku]);

    return (
        <div className={s.cartItem}>
            <BaseLensesProductItem
                nameComponent={
                    <ProductName
                        id={item.id}
                        isCartPage={false}
                        sku={item.product.sku}
                        windowName={item.windowName}
                    />
                }
                item={item as unknown as QuoteItemV2}
            >
                <LensesSubscriptionQuantity item={item} />
                <button
                    className={s.moreDetailsBtn}
                    onClick={() => setIsOpened(!isOpened)}
                    type="button"
                >
                    <span className={s.moreDetailsTitle}>More Details</span>
                    <Icon
                        className={classNames(s.arrow, {
                            [s.iconActive]: isOpened,
                        })}
                        height={6}
                        icon={ArrowDown}
                        strokeWidth={2}
                        width={10}
                    />
                </button>
            </BaseLensesProductItem>
            <AnimateHeight duration={300} height={isOpened ? 'auto' : 0}>
                <LensesCartItemDetails item={item} />
            </AnimateHeight>
        </div>
    );
};
